import { render, staticRenderFns } from "./MessagePopUp.vue?vue&type=template&id=2583d31a&scoped=true"
import script from "./MessagePopUp.vue?vue&type=script&lang=js"
export * from "./MessagePopUp.vue?vue&type=script&lang=js"
import style0 from "./MessagePopUp.vue?vue&type=style&index=0&id=2583d31a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583d31a",
  null
  
)

export default component.exports